import orderBy from "lodash/orderBy";
import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {cabinetThumbnail} from "../assets";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

import BottomCabinet from "../subparts/cabinet/bottomCabinet";
import TopCabinet from "../subparts/cabinet/topCabinet";
import CrownMolding from "../subparts/cabinet/crownMolding";
import TopHandle from "../subparts/cabinet/topHandle";
import BottomHandle from "../subparts/cabinet/bottomHandle";
import TopCabinetShadow from "../subparts/cabinet/topCabinetShadow";
import BottomCabinetShadow from "../subparts/cabinet/bottomCabinetShadow";

export default class Cabinet extends Part {
  static id = 'Cabinet';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Cabinet';
    this.partThumbnail = cabinetThumbnail;
    this.partThumbnailSize = "70%";
    this.translateId = "visualizer.kitchen.cabinet";

    // related items
    this.topCabinet = null;
    this.bottomCabinet = null;
    this.crownMolding = null;
    this.topHandle = null;
    this.bottomHandle = null;
    this.topCabinetShadow = null;
    this.bottomCabinetShadow = null;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Bottom Cabinet":
        relatedItemName = "bottomCabinet";
        RelatedItemClass = BottomCabinet;
        break;
      case "Top Cabinet":
        relatedItemName = "topCabinet";
        RelatedItemClass = TopCabinet;
        break;
      case "Crown Molding":
        relatedItemName = "crownMolding";
        RelatedItemClass = CrownMolding;
        // if (dbFeature.metaData && dbFeature.metaData["Parts"]) {
        //   relatedItemName = "crownMolding";
        //   RelatedItemClass = CrownMolding;
        // }
        break;
      case "Top Handle":
        relatedItemName = "topHandle";
        RelatedItemClass = TopHandle;
        break;
      case "Bottom Handle":
        relatedItemName = "bottomHandle";
        RelatedItemClass = BottomHandle;
        break;
      case "Top Cabinet Shadow":
        relatedItemName = "topCabinetShadow";
        RelatedItemClass = TopCabinetShadow;
        break;
      case "Bottom Cabinet Shadow":
        relatedItemName = "bottomCabinetShadow";
        RelatedItemClass = BottomCabinetShadow;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Cabinet', this);
  }

  isSubTypeWithItems() {
    return false;
  }

  getRelatedItems() {
    return orderBy(this.relatedItems, 'layerPriority');
  }

  subParts(withHidden = true, hideWithoutFeatures = false) {
    return this.getRelatedItems()
      .filter(item => this.filterRelatedItem(item, withHidden))
      .filter(item => {
        if ((item.partId === "crown_molding" || item.partId === "top_handle") && hideWithoutFeatures && item.allFeaturesReceived) {
          return item.navigationSubItems({}, "").length
        }
        return item
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  handleSubPartClick() {

  }

  getTopCabinetType() {
    if (this.topCabinet && this.topCabinet.activeFeature) {
      if (this.topCabinet.activeFeature.dbFeature.metaData["Cabinet"]) {
        return this.topCabinet.activeFeature.dbFeature.metaData["Cabinet"][0]
      } else {
        // console.log("no topCabinet metaData!", this.topCabinet.activeFeature);
        return ""
      }
    }
    return ""
  }

  // getTopCabinetLayout() {
  //
  //   if (this.topCabinet && this.topCabinet.activeFeature) {
  //     if (this.topCabinet.activeFeature.dbFeature.metaData["Cabinet"]) {
  //       return this.topCabinet.activeFeature.dbFeature.metaData["Cabinet"][0]
  //     } else {
  //       // console.log("no topCabinet metaData!", this.topCabinet.activeFeature);
  //       return ""
  //     }
  //   }
  //   return "ALL"
  // }

  getBottomCabinetType() {
    if (this.bottomCabinet && this.bottomCabinet.activeFeature) {
      if (this.bottomCabinet.activeFeature.dbFeature.metaData["Cabinet"]) {
        return this.bottomCabinet.activeFeature.dbFeature.metaData["Cabinet"][0]
      } else {
        // console.log("no bottomCabinet metaData!", this.bottomCabinet.activeFeature);
        return ""
      }
    }
    return ""
  }

  getTopCabinetApplianceType() {
    if (this.topCabinet && this.topCabinet.activeFeature) {
      if (this.topCabinet.activeFeature.dbFeature.metaData["Appliance"]) {
        return this.topCabinet.activeFeature.dbFeature.metaData["Appliance"][0]
      } else {
        // console.log("no Appliance metaData!", this.topCabinet.activeFeature);
        return "Hood"
      }
    }
    return "Hood"
  }

  getTopCabinetShadowLayout() {
    if (this.topCabinet && this.topCabinet.activeFeature && this.topCabinet.activeFeature.dbFeature.metaData["CabinetLayout"]) {
      return this.topCabinet.activeFeature.dbFeature.metaData["CabinetLayout"][0]
    }
    return ""
  }

  getBottomCabinetApplianceType() {
    if (this.bottomCabinet && this.bottomCabinet.activeFeature) {
      if (this.bottomCabinet.activeFeature.dbFeature.metaData["Appliance"]) {
        return this.bottomCabinet.activeFeature.dbFeature.metaData["Appliance"][0]
      } else {
        // console.log("no Appliance metaData!", this.bottomCabinet.activeFeature);
        return "Range"
      }
    }
    return "Range"
  }

}
